import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import Input from "@/components/forms/Input.tsx";
import type { RefDaysModalProps } from "./RefDaysModal.types";

const RefDaysModal: React.FC<RefDaysModalProps> = (
    {
        open,
        value,
        onClose,
        onConfirm,
    }) => {
    const [draft, setDraft] = useState<string>(String(value));

    useEffect(() => {
        if (open) {
            setDraft(String(value));
        }
    }, [open, value]);

    const parsed = Number.parseInt(draft, 10);
    const isValid = Number.isFinite(parsed) && parsed > 0 && parsed <= 365;

    const handleConfirm = () => {
        if (!isValid) {
            return;
        }
        onConfirm(parsed);
        onClose();
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Quantité jour référence"
            size="sm"
            footer={
                <>
                    <button
                        onClick={onClose}
                        className="inline-flex items-center rounded-full bg-gray-200 cursor-pointer px-4 py-2 font-medium text-gray-700 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                    >
                        Annuler
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={!isValid}
                        title={!isValid ? "Entrez un nombre de jours entre 1 et 365" : undefined}
                        className={`inline-flex items-center rounded-full px-4 py-2 font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 ${isValid ? "bg-green-600 cursor-pointer hover:bg-green-700" : "bg-green-600 opacity-50 cursor-not-allowed"}`}
                    >
                        Confirmer
                    </button>
                </>
            }
        >
            <div className="flex flex-col gap-3 text-gray-700">
                <div className="flex items-center gap-2">
                    <Input
                        type="number"
                        min={1}
                        max={365}
                        autoFocus
                        value={draft}
                        onChange={(e) => setDraft(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                handleConfirm();
                            }
                        }}
                        className="w-28"
                    />
                    <span className="text-sm text-gray-500">jours</span>
                </div>
            </div>
        </Modal>
    );
};

export default RefDaysModal;
